"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Helpers to calculate time units into milliseconds
 * @private
 * @property {number} s
 *   Use for seconds
 * @property {number} m
 *   Use for minutes
 * @property {number} h
 *   Use for hours
 * @property {number} d
 *   Use for days
 */
var dateHelpers = {
  s: 1000,
  m: 60000,
  h: 3600000,
  d: 86400000
};

exports.default = dateHelpers;